import home1 from './home1.mp4';
import home2 from './home2.mp4';
import home3 from './home3.mp4';
import home4 from './home4.mp4';
import home5 from './home5.mp4';
import home6 from './home6.mp4';
import home7 from './home7.mp4';
import home8 from './home8.mp4';

export const HERO_VIDEOS = [home1, home2, home3, home4, home5, home6, home7, home8];
